import { createApp } from '@/create-app/createApp';
import { initDataDog } from '@/datadog-client-setup';
import { type StateTree } from 'pinia';
import App from './AppHg.vue';

initDataDog();

(async () => {
  const { app, router, pinia } = createApp(App);

  const initialPiniaState = window.__PINIA_INITIAL_STATE__;

  if (initialPiniaState) {
    pinia.state.value = initialPiniaState as Record<string, StateTree>;
  }

  await router.isReady();
  app.mount('#app');

  // Mark the app as hydrated so E2E tests can detect when Vue
  // has finished hydrating and event handlers are attached.
  document.getElementById('app')?.setAttribute('data-hydrated', '');
})();
